export type DayAccent = {
  bar: string
  meta: string
  /** Speaker avatar border — same hue as `bar` */
  avatarBorder: string
}

export const DAY_ACCENTS: Record<'may11' | 'may12' | 'may13', DayAccent> = {
  may11: {
    bar: 'bg-secondary-blue-100',
    meta: 'text-secondary-blue-100',
    avatarBorder: 'border-secondary-blue-100',
  },
  may12: {
    bar: 'bg-primary-green-85',
    meta: 'text-primary-green-85',
    avatarBorder: 'border-primary-green-85',
  },
  may13: {
    bar: 'bg-secondary-purple-100',
    meta: 'text-secondary-purple-100',
    avatarBorder: 'border-secondary-purple-100',
  },
}

export type AccentKey = keyof typeof DAY_ACCENTS
